<ngx-sonner-toaster richColors closeButton/>
<router-outlet></router-outlet>